import { motion } from "framer-motion";
import { FiMail, FiMessageSquare, FiMapPin, FiClock } from "react-icons/fi";
import { useLanguage } from "../contexts/LanguageContext";

const Contact = () => {
    const { t } = useLanguage();
    return (
        <div className="py-12 space-y-12">
            {/* Header */}
            <section className="text-center space-y-8">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6 }}
                >
                    <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-r from-purple-500 to-blue-500 text-white rounded-2xl mb-6">
                        <FiMessageSquare className="w-8 h-8" />
                    </div>
                    <h1 className="text-4xl md:text-6xl font-bold bg-gradient-to-r from-purple-600 via-blue-600 to-cyan-600 bg-clip-text text-transparent mb-6">
                        {t("contact.title")}
                    </h1>
                    <p className="text-xl text-gray-600 dark:text-gray-400 max-w-3xl mx-auto leading-relaxed">
                        {t("contact.subtitle")}
                    </p>
                </motion.div>
            </section>

            {/* Contact Info */}
            <section className="max-w-4xl mx-auto">
                {/* Contact Form */}

                {/* Contact Information */}
                <motion.div
                    initial={{ opacity: 0, x: 20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.6, delay: 0.4 }}
                    className="space-y-8"
                >
                    <h2 className="text-2xl font-bold">
                        {t("contact.infoTitle")}
                    </h2>

                    <div className="space-y-6">
                        <div className="flex items-start space-x-4 p-6 bg-white dark:bg-gray-800 rounded-2xl border border-gray-200 dark:border-gray-700">
                            <div className="flex-shrink-0 w-12 h-12 bg-gradient-to-r from-purple-500 to-blue-500 text-white rounded-xl flex items-center justify-center">
                                <FiMail className="w-6 h-6" />
                            </div>
                            <div>
                                <h3 className="text-lg font-semibold mb-2">
                                    {t("contact.emailTitle")}
                                </h3>
                                <p className="text-gray-600 dark:text-gray-400 mb-2">
                                    mewseeds@gmail.com
                                </p>
                                <p className="text-sm text-gray-500 dark:text-gray-500">
                                    {t("contact.emailDesc")}
                                </p>
                            </div>
                        </div>

                        <div className="flex items-start space-x-4 p-6 bg-white dark:bg-gray-800 rounded-2xl border border-gray-200 dark:border-gray-700">
                            <div className="flex-shrink-0 w-12 h-12 bg-gradient-to-r from-purple-500 to-blue-500 text-white rounded-xl flex items-center justify-center">
                                <FiMapPin className="w-6 h-6" />
                            </div>
                            <div>
                                <h3 className="text-lg font-semibold mb-2">
                                    {t("contact.siteTitle")}
                                </h3>
                                <p className="text-gray-600 dark:text-gray-400 mb-2">
                                    https://mewseeds.com
                                </p>
                                <p className="text-sm text-gray-500 dark:text-gray-500">
                                    {t("contact.siteDesc")}
                                </p>
                            </div>
                        </div>

                        <div className="flex items-start space-x-4 p-6 bg-white dark:bg-gray-800 rounded-2xl border border-gray-200 dark:border-gray-700">
                            <div className="flex-shrink-0 w-12 h-12 bg-gradient-to-r from-purple-500 to-blue-500 text-white rounded-xl flex items-center justify-center">
                                <FiClock className="w-6 h-6" />
                            </div>
                            <div>
                                <h3 className="text-lg font-semibold mb-2">
                                    {t("contact.timeTitle")}
                                </h3>
                                <p className="text-gray-600 dark:text-gray-400 mb-2">
                                    {t("contact.timeValue")}
                                </p>
                                <p className="text-sm text-gray-500 dark:text-gray-500">
                                    {t("contact.timeDesc")}
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* FAQ Section */}
                    <div className="space-y-4">
                        <h3 className="text-xl font-bold">
                            {t("contact.faqTitle")}
                        </h3>
                        <div className="space-y-4">
                            <div className="p-4 bg-gray-50 dark:bg-gray-800 rounded-xl">
                                <h4 className="font-semibold mb-2">
                                    {t("contact.faq1.q")}
                                </h4>
                                <p className="text-sm text-gray-600 dark:text-gray-400">
                                    {t("contact.faq1.a")}
                                </p>
                            </div>
                            <div className="p-4 bg-gray-50 dark:bg-gray-800 rounded-xl">
                                <h4 className="font-semibold mb-2">
                                    {t("contact.faq2.q")}
                                </h4>
                                <p className="text-sm text-gray-600 dark:text-gray-400">
                                    {t("contact.faq2.a")}
                                </p>
                            </div>
                            <div className="p-4 bg-gray-50 dark:bg-gray-800 rounded-xl">
                                <h4 className="font-semibold mb-2">
                                    {t("contact.faq3.q")}
                                </h4>
                                <p className="text-sm text-gray-600 dark:text-gray-400">
                                    {t("contact.faq3.a")}
                                </p>
                            </div>
                        </div>
                    </div>
                </motion.div>
            </section>
        </div>
    );
};

export default Contact;
